import React from "react";

import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";

import AssessmentTableViewRow from "./AssessmentTableViewRow";
import { EmptyState, TableLoading } from "../../../common";
import { results_dashbodard_interview_table_columns } from "../../../static/table-columns";

const AssessmentTableView = ({
  tableData,
  totalAssessments,
  page,
  setPage,
  rowsPerPage,
  onRowsPerPageChange,
  isLoading,
}) => {
  const isEmpty = tableData ? tableData?.length === 0 : false;

  return (
    <Card
      sx={{ px: 2, pt: 1, width: "97%", borderTop: 1, borderColor: "#E9EBF0" }}
    >
      <TableContainer
        sx={{
          overflow: "auto",
          borderColor: "#CFCFCF",
          width: "100%",
          borderRadius: "8px",
          maxWidth: "100%",
          "& .MuiTableRow-root:hover": { backgroundColor: "primary.200" },
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {results_dashbodard_interview_table_columns?.map((column, i) => (
                <TableCell
                  key={column.id}
                  align={i === 0 ? "left" : "center"}
                  sx={{ minWidth: "250px", bgcolor: "#f3f4f6" }}
                >
                  <Typography
                    fontSize={"15px"}
                    fontWeight={600}
                    color="#21282F"
                  >
                    {column.label}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {isLoading ? (
              <TableLoading noOfColumns={5} />
            ) : (
              tableData?.map((id) => (
                <AssessmentTableViewRow key={id} id={id} />
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {isEmpty && !isLoading && (
        <EmptyState
          title="Looks like there's no assessments conducted yet."
          top={"10%"}
          sx={{ my: 5 }}
        />
      )}
      {tableData?.length > 0 && (
        <TablePagination
          component="div"
          count={totalAssessments}
          page={page - 1}
          onPageChange={(_, newPage) => setPage(newPage + 1)}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={onRowsPerPageChange}
          sx={{
            fontFamily: "Outfit",
            "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
              {
                fontFamily: "Outfit",
              },
            "& .MuiInputBase-root": {
              fontFamily: "Outfit",
            },
          }}
        />
      )}
    </Card>
  );
};

export default AssessmentTableView;
